"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonInteractionLayer = void 0;
const React = require("react");
const bronson_react_1 = require("@vwfs-bronson/bronson-react");
const BronsonInteractionLayer = (props) => {
    return (React.createElement(bronson_react_1.InteractionLayer, { id: props.id, isHidden: props.isClose, onClose: props.closeAction, closeButtonLabel: `close-layer-${props.id}` }, props.children));
};
exports.BronsonInteractionLayer = BronsonInteractionLayer;
